import { ScreenName, Screen } from "./DirectApplyTypes";

const impressionBase = {
    sp_impression_component: "modal",
    sp_impression_position: "pop_up",
    sp_impression_modal_type: "direct_apply",
    sp_tags: []
};

const screenNames: ScreenName[]  = [
    "direct_apply_email_registration",
    "contact_details",
    "attachment_upload",
    "review_application",
    "apply_confirmation"
];

/**
 * All configuration of screens happens here.
 */
const screenMeta: Screen[] = [
    {
        name: screenNames[0],
        step: 1,
        impression: {
            ...impressionBase,
            sp_modal_screen_name: screenNames[0],
            sp_modal_screen_order: 1,
        },
        validate: ["email", "location"],
        required: ["email", "location"],
        btnLabel: "continue",
    },
    {
        name: screenNames[1],
        step: 2,
        impression: {
            ...impressionBase,
            sp_modal_screen_name: screenNames[1],
            sp_modal_screen_order: 2,
        },
        validate: ["firstName", "lastName", "phone"],
        required: ["firstName", "lastName", "phone"],
        btnLabel: "continue",
    },
    {
        name: screenNames[2],
        step: 3,
        impression: {
            ...impressionBase,
            sp_modal_screen_name: screenNames[2],
            sp_modal_screen_order: 3,
        },
        validate: ["resume", "resumeName", "resumeStats", "coverLetterName", "coverLetterStats"],
        required: ["resume", "resumeName", "resumeStats"],
        btnLabel: "continue",
    },
    {
        name: screenNames[3],
        step: 4,
        impression: {
            ...impressionBase,
            sp_modal_screen_name: screenNames[3],
            sp_modal_screen_order: 4,
        },
        validate: [],
        required: [],
        btnLabel: "submit",
    },
    {
        name: screenNames[4],
        step: 5,
        impression: {
            ...impressionBase,
            sp_modal_screen_name: screenNames[4],
            sp_modal_screen_order: 5,
        },
        validate: [],
        required: [],
        btnLabel: "close",
    },
];

/**
 * Get the screens meta data by the step number.
 */
const getScreenByStep = (step: number) => screenMeta.find((x) => x.step === step) ?? screenMeta[0];

export {
    getScreenByStep,
    impressionBase,
    screenMeta
};
